import { FC, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// Types
import UserPermissions from 'app/types/Permissions';
// Models
import { RootState } from 'app/store';
import IEpisode from 'app/models/Episode';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { EpisodesActions } from 'app/store/Episodes/Episodes.slice';
// Selectors
import { selectMyUserHasPermission } from 'app/store/Users/Users.selectors';
import { selectPageEpisodesAll } from 'app/store/Episodes/Episodes.selectors';
// Async
import { getFacts } from 'app/store/EpisodeFacts/EpisodeFacts.async';
// Context
import PageEpisodesProvider from 'app/context/PageEpisodes.context';
// ToDO
import { IPage } from '@root/models/Page';
import { selectPage } from 'app/store/page/page.selectors';
// End: ToDO
// Utilities
import { getSearchParam } from 'app/utilities/Utilities';
// 
import SortByButton from './SortByButton';
import CreateEpisodeButton from './CreateEpisodeButton';
import DeleteAllEpisodesButton from './DeleteAllEpisodesButton';
import EpisodeList from './EpisodeList';

type Props = {
  activeEpisodeId?: number;
  openedFromPreview?: boolean;
  children?: React.ReactNode;
}

const EpisodesComponent:FC<Props> = ({ activeEpisodeId, openedFromPreview, children }) => {
  const { search, pathname } = useLocation<{ search:string, pathname:string }>();
  const episodeId = getSearchParam(search, 'episodeId');
  const { pageNum } = useParams<{ pageNum:string }>();

  const isSearchPage = pathname.includes('/search');
  const isPageRoute = !!pageNum;

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const myUserCPTEnabled = useAppSelector((state:RootState) => selectMyUserHasPermission(state, {
    permission: UserPermissions.HcpcsCodes
  }));
  // ToDO
  const page = useAppSelector((state) => selectPage(state as any)) as IPage;

  // End: ToDO
  const episodes = useAppSelector((state) => selectPageEpisodesAll(state, {
    documentId: page?.documentId,
    pageNum: page?.pageNum,
    stapleId: page?.staple && (isPageRoute || page?.staple.order === 1) ? page.staple.id : undefined,
    parentEpisodeId: page?.parentEpisodeId
  })) as IEpisode[] | null;

  useEffect(() => {
    const nextEpisodeId = activeEpisodeId ??
      (episodeId ? Number(episodeId) : undefined) ??
      (!isSearchPage && !isPageRoute && !openedFromPreview ? page?.parentEpisodeId : undefined);

    if ( nextEpisodeId ) {
      dispatch(EpisodesActions.setSelectedEpisodeId(nextEpisodeId));
    }

    if ( !myUserCPTEnabled || !episodes || !episodes.length ) return;

    const episodeIds = episodes.map((episode:IEpisode) => episode.id).join(',');

    dispatch(getFacts({ episodeIds }));
    // eslint-disable-next-line
  }, []);

  return (
    <PageEpisodesProvider page={page} episodes={episodes || []} isPageRoute={isPageRoute} activeEpisodeId={activeEpisodeId} openedFromPreview={openedFromPreview}>{children}</PageEpisodesProvider>
  );
}

const Episodes = Object.assign(EpisodesComponent, {
  SortBy: SortByButton,
  CreateButton: CreateEpisodeButton,
  DeleteAllButton: DeleteAllEpisodesButton,
  List: EpisodeList
});

export default Episodes;
